import { render, staticRenderFns } from "./MemberDetail.vue?vue&type=template&id=bdcbb4a0&scoped=true"
import script from "./MemberDetail.vue?vue&type=script&lang=js"
export * from "./MemberDetail.vue?vue&type=script&lang=js"
import style0 from "./MemberDetail.vue?vue&type=style&index=0&id=bdcbb4a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcbb4a0",
  null
  
)

export default component.exports